<template>
  <div id="autovote">
    <h1>点赞设置</h1>

    <div id="titlename">
    <b-input
      id="inline-form-input-name"
      class="mb-2 mr-sm-2 mb-sm-0 cate"
      placeholder="请输入作者名" v-model="author"
    ></b-input>
    <b-input
      id="inline-form-input-name"
      class="mb-2 mr-sm-2 mb-sm-0 cate"
      placeholder="请输入点赞比重：0~100" v-model="weight"
    ></b-input></div>
    <div class="addbtn">
    <b-button variant="outline-primary" @click="add">添加</b-button>
    </div>

    <!--加载动画-->
    <transition name="fade">
      <loading v-if="isLoading"></loading>
    </transition>

    <div v-for="item in authors" class="votelist">
      <p class="author">作者: {{ item.author }} 　点赞比重: {{ item.weight }} %　
        <b-button variant="outline-primary" @click="del(item.author)" id="del">删除</b-button> </p>
    </div>

    <div class="addbtn">
      <span v-if="autoFlag">
      <b-button variant="outline-primary" @click="saveAndStart">保存并开始</b-button>
     </span>
      <span v-else style="color:#da741b;">
       已开始自动点赞...... 　 　<b-button variant="outline-primary" @click="stop">停止</b-button>
    </span>



    </div>

  </div>
</template>

<script>
  import Loading from './Loading'
    export default {
        name: "AutoVote",
      data(){
        return {
          newpost: [],
          author:'',
          weight: '',
          autoFlag: true,
          isLoading: false,
          authors: [{author: 'lemooljiang', weight: 100}]
        }
      },

      methods: {
        add(){
          this.autoFlag = true
          this.isLoading = true
          let that = this
          let authors = { author: this.author, weight: this.weight}
          //判断作者是否存在
          let account = this.author
          this.steem.api.getAccountHistory(account, 0, 0, function(err, result) {
            // console.log(333, err, result)
            if(result.length === 0){
              that.isLoading = false
              alert("此作者不存在！")
            }else{
              that.isLoading = false
              that.authors.push(authors)
              that.author= that.weight = ''
            }
          })


        },
        saveAndStart(){
          this.autoFlag = false
          let au = JSON.stringify(this.authors)
          localStorage.setItem('authors', au)
          localStorage.setItem('autostart','SteemJiang')
          //直接刷新当前页面
          this.$router.go(0)
        },
        stop(){
          this.autoFlag = true
          localStorage.removeItem('autostart')
          //直接刷新当前页面
          this.$router.go(0)
        },
        del(author){
          this.autoFlag = true
          this.authors.splice(this.authors.findIndex(item => item.author === author), 1)
        }
      },

      components: {
        Loading
      },

      mounted() {
          if(localStorage.getItem("authors") == null){
            this.authors = [
              {author: 'lemooljiang', weight: 100}
            ]
          }else{
            this.authors = JSON.parse(localStorage.getItem("authors"))
          }

          if(localStorage.getItem("autostart") !=null){
            this.autoFlag = false
          }

      }
    }
</script>

<style scoped>
  h1{
    font-size: 2rem;
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
    padding-bottom: 1rem;
    border-bottom: 1px solid #ddd;
    padding-left: 2rem;
  }
 #inline-form-input-name{
   display: inline;
   width: 20rem;
 }
  #autovote{
    color: rgba(55,53,58,0.75);
    align: center;
    margin: 1rem auto;
    width: 70%;
  }
  #titlename{
    padding-left: 2rem;
  }
  .cate{
    margin-top: 0.8rem;
    margin-bottom: 0.8rem;
    width: 2rem;

  }
  .addbtn{
    margin-top: 1rem;
    margin-bottom: 2rem;
    padding-left: 2rem;
  }

  .votelist{
    margin-top: 0.5rem;
    padding-left: 2rem;
    padding-right: 2rem;
    align: center;
    border: 1px dashed #ddd;
   }
  .author{
    font-size: 1rem;
    margin-top: 0.4rem;
    margin-bottom: 0.4rem;
  }
  .posttime{
    font-size: 0.8rem;
    display: inline;
  }




  a{
    color: rgba(55,53,58,0.75);
  }

  a:hover{
    color: darkcyan;
    text-decoration: none;

  }

  .btn-outline-primary {
    color: rgba(55,53,58,0.75);
    border-color: rgba(55,53,58,0.75);
  }
  .btn-outline-primary:hover{
    background-color: chocolate;
  }

  #del {
    color: rgba(55, 53, 58, 0.75);
    border-color: transparent;
    font-size: 0.7rem;
  }
  #del:hover{
    background-color: transparent;
    color: darkcyan;
  }


</style>
